import { DocumentNode } from 'apollo-link';
import client from 'graphql/client';
import { v4 } from 'uuid';

export async function fetcher<TData, TVariables>(
  endpoint: string,
  requestInit: any,
  query: string,
  variables?: TVariables,
  operationName = 'operation:' + v4()
) {
  const res = await fetch(endpoint, {
    method: 'POST',
    ...(requestInit || {}),
    body: JSON.stringify({ query, variables, operationName }),
  });

  const json = await res.json();

  if (json.errors) {
    const { message } = json.errors[0];

    throw new Error(message);
  }

  return json.data as TData;
}

export async function fetcherWithGraphql<TData, TVariables>(
  query: DocumentNode,
  variables?: TVariables,
  options?: any,
  _key?: string
) {
  const res = await client.query({
    query,
    variables,
    fetchPolicy: 'no-cache',
    ...options,
  });

  if (res.errors) {
    const { message } = res.errors[0];

    throw new Error(message);
  }

  return res.data as TData;
}
